module.exports = __webpack_public_path__ + "img/banktransfer.9abaa9a6.png";